<template>
  <div class="contents userMgt">
    <div class="title flexB">
      <h2>컨텐츠 관리</h2>
    </div>
    <div class="box one filter">
      <div class="flex">
        <p class="bold">검색조건</p>
        <select v-model="inputMode">
          <option value="" selected disabled>선택</option>
          <option value="title">제목</option>
          <option value="url">URL</option>
        </select>
        <input type="text" v-model="searchWord" @keyup.enter="search" />
      </div>
      <div class="flex">
        <p class="bold">카테고리</p>
        <label>
          <input type="radio" value="" checked v-model="category" />전체
        </label>
        <label>
          <input type="radio" value="결혼준비" v-model="category" />
          결혼준비
        </label>
        <label>
          <input type="radio" value="웨딩장소" v-model="category" />
          웨딩장소
        </label>
        <label>
          <input type="radio" value="웨딩컬렉션" v-model="category" />
          웨딩컬렉션
        </label>
        <label>
          <input type="radio" value="허니문" v-model="category" />
          허니문
        </label>
        <label>
          <input type="radio" value="혼수컬렉션" v-model="category" />
          혼수컬렉션
        </label>
        <label>
          <input type="radio" value="썬데이살롱" v-model="category" />
          썬데이 살롱
        </label>
        <label>
          <input type="radio" value="더플래너TV" v-model="category" />
          더플래너 TV
        </label>
      </div>
      <div class="buttonWrap">
        <button class="basic" @click="search">검색</button>
        <button class="line" @click="reset">초기화</button>
      </div>
    </div>

    <div class="box one">
      <h2 class="bold">
        컨텐츠 리스트
        <button class="right basic">
          <router-link to="/admin/archivemanage/register"
            >컨텐츠 등록</router-link
          >
        </button>
      </h2>
      <table v-if="archiveList.length > 0">
        <colgroup>
          <col style="width: 10%" />
          <col style="width: 15%" />
          <col style="width: 60%" />
          <col style="width: 15%" />
        </colgroup>
        <tr>
          <th>번호</th>
          <th>카테고리</th>
          <th>게시글 제목</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in archiveList" :key="i">
          <td>{{ total + 1 - (i + 1 + (currentPage - 1) * 10) }}</td>
          <td>{{ data.category }}</td>
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              data.title
            }}</router-link>
          </td>
          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <NoData v-if="isNodata" />
      <div class="pagination" v-else>
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { fetchArchivePostList } from "@/api/admin";
import NoData from "@/components/contents/Nodata";
import { format } from "@/mixins/format";
export default {
  name: "toymanage",
  mixins: [format],
  components: { NoData },
  data() {
    return {
      moment: moment,
      category: "",
      archiveList: [],
      inputMode: "",
      searchWord: "",
      total: 0,
      currentPage: 1,
      isNodata: false,
    };
  },
  computed: {
    ...mapState(["navbarState"]),
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "5-3");
  },
  mounted() {
    this.getArchveList();
  },
  methods: {
    reset() {
      this.inputMode = "";
      this.searchWord = "";
      this.category = "";
      this.currentPage = 1;
      this.archiveList = [];
      this.total = 0;
      this.getArchveList();
    },
    search() {
      if (this.searchWord && this.inputMode == "") {
        this.$alert("검색 조건을 선택해 주세요.", {
          confirmButtonText: "확인",
          center: true,
        });
        return;
      }
      this.getArchveList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getArchveList();
    },
    handleMove(id) {
      this.$router.push({ name: "archiveRegister", query: { id: id } });
    },
    getArchveList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        inputMode: this.inputMode,
        category: this.category,
      };
      fetchArchivePostList(params).then((res) => {
        if (res.data.status == 200) {
          this.archiveList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
        } else {
          this.$alert(res.data.message, {
            confirmButtonText: "확인",
            center: true,
          });
        }
      });
    },
  },
};
</script>
